import { Box } from '@factorialco/deprecated-design-system'
import { F0TagStatus } from '@factorialco/f0-react'
import { FinanceValueObjectsInvoiceStatusEnum } from 'generated/resources/graphql'

import { mapSaleInvoiceStatusText, saleInvoiceStatusTagType } from 'modules/finance/lib/invoices'

interface StatusProps {
  validated?: boolean
  registered?: boolean
  status?: FinanceValueObjectsInvoiceStatusEnum
}

export const SaleInvoiceStatus = ({ validated, registered, status }: StatusProps) => {
  return (
    <Box alignItems="flexStart">
      <F0TagStatus
        text={mapSaleInvoiceStatusText(validated, registered, status)}
        variant={saleInvoiceStatusTagType(validated, registered, status)}
      />
    </Box>
  )
}
